<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <b-card
      no-body
    >
      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <b-form-group
            class="mr-1 mb-md-0"
          >
            <b-button
              v-b-modal.modal-1
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              block
              @click="addData"
            >
              <i class="fad fa-donate" />
              เติมเครดิต
            </b-button>
          </b-form-group>
          <b-form-group
            label="Filter"
            label-cols-sm="2"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="search_val"
                type="search"
                placeholder="Search Username"
                @keyup.enter="getDeposit()"
              />
              <b-input-group-append>
                <b-button
                  :disabled="!search_val"
                  @click="search_val = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-card-body>
      <b-table
        striped
        hover
        responsive
        class="position-relative items-center"
        :per-page="perPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
      >
        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + (data.index + 1) }}
        </template>
        <template #cell(picture)="data">
          <b-avatar
            size="lg"
            :src="data.item.picture"
          />
        </template>
        <template #cell(ip)="data">
          <div class="text-nowrap">
            <a
              :href="`http://${data.item.ip}`"
              target="_blank"
            >{{ data.item.ip }}</a>

          </div>
        </template>
        <!-- Column: Detail -->
        <template #cell(detail)="data">
          <div class="text-nowrap">
            <feather-icon
              :id="`invoice-row-${data.item.id}-preview-icon`"
              icon="FileTextIcon"
              size="16"
              class="mx-1"
              @click="$router.push({ name: 'Deposit-Withdraw', params: { id: data.item.username }})"
            />
            <b-tooltip
              title="History Deposit & Withdraw"
              :target="`invoice-row-${data.item.username}-preview-icon`"
            />
          </div>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <!-- <feather-icon
            :id="`invoice-row-${data.item.id}-preview-icon`"
            icon="EyeIcon"
            size="16"
            class="mx-1"
            @click="$router.push({ name: 'dashboard', params: { id: data.item.id }})"
          />
          <b-tooltip
            title="Preview Invoice"
            :target="`invoice-row-${data.item.id}-preview-icon`"
          /> -->
            <feather-icon
              :id="`invoice-row-${data.item.id}-preview-icon`"
              icon="EditIcon"
              size="16"
              class="mx-1"
              @click="editData(data.item)"
            />
            <b-tooltip
              title="Preview Invoice"
              :target="`invoice-row-${data.item.id}-preview-icon`"
            />
          </div>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @change="getDeposit()"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="getDeposit()"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
      <b-modal
        id="modal-1"
        title="เติมเครดิต"
        ok-title="เติมเครดิต"
        @ok="submit"
      >
        <validation-observer ref="simpleRules">
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              name="member"
              rules="required"
            >
              <v-select
                v-model="member"
                name="member"
                :state="errors.length > 0 ? false:null"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="username"
                :options="optionsMember"
              />
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="จำนวนเงินที่ฝาก"
            label-for="vi-first-name"
          >
            <validation-provider
              #default="{ errors }"
              name="amount"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <i class="fad fa-donate" />
                </b-input-group-prepend>
                <b-form-input
                  id="vi-first-name"
                  v-model="amount"
                  name="amount"
                  :state="errors.length > 0 ? false:null"
                  placeholder=""
                />
              </b-input-group>
            </validation-provider>
          </b-form-group>

          <label for="time">เวลา (ใน สลิป)</label>
          <div style="display: flex">
            <b-form-select
              v-model="time"
              :options="timeOp1"
              style="width: 80px"
            />
            &nbsp;:&nbsp;

            <b-form-select
              v-model="time2"
              :options="timeOp2"
              style="width: 80px"
            />
          </div>
        </validation-observer>
      </b-modal>
    </b-card>
  </b-overlay>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import moment from 'moment-timezone'
import {
  BOverlay, BIconController, BInputGroupPrepend, BModal, BCard, BTable, BAvatar, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, VBToggle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'

export default {
  components: {
    vSelect,
    BInputGroupPrepend,
    BModal,
    BCard,
    BTable,
    BAvatar,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BOverlay,
    BIconController,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      emailValue: '',
      time: null,
      time2: null,
      name: '',
      required,
      email,
      search_val: null,
      show: true,
      depositdata: [],
      member: '',
      amount: '',
      optionsMember: '',
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      usersList: [],
      datasidebar: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      timeOp1: [
        { value: '00', text: '00' }, { value: '01', text: '01' },
        { value: '02', text: '02' }, { value: '03', text: '03' },
        { value: '04', text: '04' }, { value: '05', text: '05' },
        { value: '06', text: '06' }, { value: '07', text: '07' },
        { value: '08', text: '08' }, { value: '09', text: '09' },
        { value: '10', text: '10' }, { value: '11', text: '11' },
        { value: '12', text: '12' }, { value: '13', text: '13' },
        { value: '14', text: '14' }, { value: '15', text: '15' },
        { value: '16', text: '16' }, { value: '17', text: '17' },
        { value: '18', text: '18' }, { value: '19', text: '19' },
        { value: '20', text: '20' }, { value: '21', text: '21' },
        { value: '22', text: '22' }, { value: '23', text: '23' },

      ],
      timeOp2: [
        { value: '00', text: '00' }, { value: '01', text: '01' },
        { value: '02', text: '02' }, { value: '03', text: '03' },
        { value: '04', text: '04' }, { value: '05', text: '05' },
        { value: '06', text: '06' }, { value: '07', text: '07' },
        { value: '08', text: '08' }, { value: '09', text: '09' },
        { value: '10', text: '10' }, { value: '11', text: '11' },
        { value: '12', text: '12' }, { value: '13', text: '13' },
        { value: '14', text: '14' }, { value: '15', text: '15' },
        { value: '16', text: '16' }, { value: '17', text: '17' },
        { value: '18', text: '18' }, { value: '19', text: '19' },
        { value: '20', text: '20' }, { value: '21', text: '21' },
        { value: '22', text: '22' }, { value: '23', text: '23' },
        { value: '24', text: '24' }, { value: '25', text: '25' },
        { value: '26', text: '26' }, { value: '27', text: '27' },
        { value: '28', text: '28' }, { value: '29', text: '29' },
        { value: '30', text: '30' }, { value: '31', text: '31' },
        { value: '32', text: '32' }, { value: '33', text: '33' },
        { value: '34', text: '34' }, { value: '35', text: '35' },
        { value: '36', text: '36' }, { value: '37', text: '37' },
        { value: '38', text: '38' }, { value: '39', text: '39' },
        { value: '40', text: '40' }, { value: '41', text: '41' },
        { value: '42', text: '42' }, { value: '43', text: '43' },
        { value: '44', text: '44' }, { value: '45', text: '45' },
        { value: '46', text: '46' }, { value: '47', text: '47' },
        { value: '48', text: '48' }, { value: '49', text: '49' },
        { value: '50', text: '50' }, { value: '51', text: '51' },
        { value: '52', text: '52' }, { value: '53', text: '53' },
        { value: '54', text: '54' }, { value: '55', text: '55' },
        { value: '56', text: '56' }, { value: '57', text: '57' },
        { value: '58', text: '58' }, { value: '59', text: '59' },

      ],
      fields: [
        { key: 'index', label: 'no.' },
        { key: 'detail', label: 'รายละเอียดลูกค้า' },
        { key: 'username', label: 'ยูสเซอร์เนม' },
        { key: 'time', label: 'เวลาในสลิป' },
        { key: 'amount', label: 'จำนวนเงินฝาก', formatter: value => this.Commas(value) },
        // { key: 'bonus', label: 'โบนัส', formatter: value => (value && value !== 0 ? this.Commas(value) : '-') },
        { key: 'balance', label: 'ยอดเครดิตรวม', formatter: value => this.Commas(value.toFixed(2)) },
        { key: 'addby', label: 'ฝากเงินโดย', formatter: value => (value === 0 ? '-' : value || '-') },
        {
          key: 'created_at',
          label: 'เวลา',
          formatter: value => moment(value)
            .tz('Asia/Bangkok')
            .format('DD/MM/YYYY HH:mm:ss'),
        },

      ],
      /* eslint-disable global-require */
      items: [],
      addNewDataSidebar: false,
      Interval: null,

    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  beforeDestroy() {
    clearInterval(this.Interval)
  },
  created() {
    this.Interval = setInterval(() => {
      this.getUserslist()
      this.getDeposit()
    }, 30000)
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    // this.Get_userlist()
    this.getUserslist()
    this.getDeposit()
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    getUserslist() {
      this.$http
        .get('https://api.rmtlotto.com/api/users/list')
        .then(response => {
          this.optionsMember = response.data
        })
        .catch(error => console.log(error))
    },
    getDeposit() {
      let index = 0
      const params = {
        page: this.currentPage,
        perPage: this.perPage,
        search_val: this.search_val,
      }
      this.$http
        .get('https://api.rmtlotto.com/api/deposit', { params })
        .then(response => {
          this.show = false
          this.depositdata = response.data.data
          this.depositdata.forEach(items => {
            this.getAdmin(items.addby, index)
            index += 1
          })
          this.onFiltered(response.data)
        })
        .catch(error => console.log(error))
    },
    getAdmin(addby, index) {
      this.$http
        .get(`https://api.rmtlotto.com/api/admin/show/${addby}`)
        .then(response => {
          this.show = false
          // console.log(response.data.name)
          this.depositdata[index].addby = response.data.name
        })
        .catch(error => console.log(error))
    },
    submit() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.time && this.time2) {
            this.show = true
            const formData = {
              username: this.member.username,
              uid: this.member.id,
              amount: this.amount,
              time: `${this.time}:${this.time2}`,
            }
            this.$http
              .post('https://api.rmtlotto.com/api/deposit/store', formData)
              .then(() => {
                this.show = false
                this.getDeposit()
                this.time = null
                this.time2 = null
                this.member = ''
                this.amount = ''
                this.Success('เติมเครดิต สำเร็จ')
              })
              .catch(error => {
                this.show = false
                this.SwalError(error.response.data.message)
              })
          } else {
            this.show = false
            this.SwalError('กรุณาใส่ให้ครบทุกช่อง')
          }
        }
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.items = filteredItems.data
      this.totalRows = filteredItems.total
      // this.currentPage = 1
    },
    Get_userlist() {
      this.$http
        .get('/api/user/list')
        .then(response => {
          this.onFiltered(response.data.message)
        })
        .catch(error => console.log(error))
    },
    Commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

.form-item-section {
background-color:$product-details-bg;
}
